export default "__VITE_ASSET__BO_Z7POL__"